import { keyboardNavigation } from "./keyboard";
import { mouseNavigation } from "./mouse";
import {
    condensedStateDesktopLogo,
    secondaryMenuDropdown,
    updateSubNavItemStyles,
    updatePrimaryNavDropdownPosition,
    updateTickerNavDropdownPosition,
    updateSecondaryNavDropdownPosition,
    nbaTickerHoverHandler,
    overflowDetector,
    enableDesktopClickDropdownsOnNoHover,
    enableClickEllipsisDropdownSubnav,
} from "../../furniture/_menu";

import { setEditionItemsWidth } from "../../furniture/_edition";

const runDesktopNavigationHandlers = () => {
    keyboardNavigation();
    mouseNavigation();
    condensedStateDesktopLogo();
    secondaryMenuDropdown();
    updateSubNavItemStyles();
    updatePrimaryNavDropdownPosition();
    updateTickerNavDropdownPosition();
    updateSecondaryNavDropdownPosition();
    nbaTickerHoverHandler();
    overflowDetector();
    enableDesktopClickDropdownsOnNoHover();
    setEditionItemsWidth();
    enableClickEllipsisDropdownSubnav();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", runDesktopNavigationHandlers);
} else {
    runDesktopNavigationHandlers();
}

window.addEventListener("resize", () => {
    setEditionItemsWidth();
});
